import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { MortgageeCustomToolTipComponent } from '../../../../widget/mortgagee-custom-tooltip/mortgagee-custom-tooltip.component';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslatePipe, MapfreDesignLibraryModule, NgSelectModule, MortgageeCustomToolTipComponent],
  selector: 'app-renewal-notice',
  templateUrl: './renewal-notice.component.html',
  styleUrls: ['./renewal-notice.component.scss']
})
export class RenewalNoticeComponent implements OnInit {
  @Input() policy: any;
  @Input() renewalPolicyList: any;
  @Input() variant: 'bn-overview' | 'policy-card' = 'bn-overview';
  isAcmic: boolean;
  isHideNotice = false;
  isRenewalPolicy = false;
  show = false;

  constructor(private acmicService: AcmicService) {
   }

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.isRenewalPolicy = this.renewalPolicyList?.some(renewalPolicy =>
      this.policy?.policynumber?.policyNumber === renewalPolicy?.policynumber?.policyNumber)
  }

  onClose(){
    this.isHideNotice = true;
  }
    onShow() {
      this.show = true;
    }
  
    onHide() {
      this.show = false;
    }
  
}